<template>
	<div class="page container">
		<div class="page__info">
			<div class="page__info--title">
				Approval queue
			</div>
		</div>
		<div class="page__nav-menu">
			<router-link
				exact
				class="page__nav-menu__link"
				activeClass="page__nav-menu__link-active"
				v-for="(link, key) in getLinks"
				:key="key"
				:to="link.route"
			>
				{{ link.text }}
			</router-link>
		</div>
		<div class="deal-packs">
			<search-input
				@search="onSearch"
			/>
			<div class="deal-packs__list">
				<v2-deal-pack-card
					v-for="dealPack in getDealPacks"
					:key="dealPack.id"
					:deal-pack="dealPack"
					adminMode
				/>
			</div>
			<records-count
				:pagination="pagination"
				:total="totalItems"
			/>
			<pagination
				v-bind="pagination"
				@paginate="onPaginate"
			/>
		</div>
	</div>
</template>

<script>
	import SearchInput    from '@/components/ui/views/SearchInput';
	import Pagination     from '@/components/ui/views/Pagination';
	import RecordsCount   from '@/components/ui/views/RecordsCount';
	import api            from '@/services/api';
	import V2DealPackCard from '@/components/dealPacks/V2DealPackCard';

	export default {
		layout: 'v2default',

		metaInfo: {
			title: 'Approval queue'
		},
		components: {
			V2DealPackCard,
			SearchInput,
			Pagination,
			RecordsCount
		},
		data: () => ({
			dealPacks: [],
			searchString: '',
			pagination: {
				perPage: 			20,
				currentPage: 	1,
				totalPages: 	0
			},
			totalItems: 0
		}),
		computed: {
			getDealPacks () {
				if (!this.dealPacks ||
						!this.dealPacks.length) {
					return false;
				}
				return this.dealPacks;
			},
			getBreadcrumbs () {
				return [
					{
						path: '/admin',
						text: 'Admin'
					},
					{
						path: '/admin/queue',
						text: 'Approval queue'
					},
					{
						path: '/admin/queue/deal-packs',
						text: 'Deal Packs'
					}
				].filter(Boolean);
			},
			getLinks () {
				return [
					{
						text: 'Courses',
						route: '/admin/queue'
					},
					{
						text: 'Deal Packs',
						route: '/admin/queue/deal-packs'
					}
				];
			}
		},
		created: function () {
			this.setDealPacks();
		},
		methods: {
			onSearch (value) {
				this.searchString = value;
				this.setDealPacks();
			},
			onPaginate (value) {
				this.pagination.currentPage = value;
				this.setDealPacks();
			},
			async setDealPacks () {
				const response = await api.admin.getDealPacks({
					include:       'metadata',
					searchString:  this.searchString,
					approval:      'pending',
					page:          this.pagination.currentPage,
					per:           this.pagination.perPage
				});
				if (!response) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.totalItems = response.meta.totalItems;
				this.pagination.totalPages = response.meta.numPages;
				this.pagination.currentPage = response.meta.page;
				this.dealPacks = response.results;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};
</script>

<style lang="scss" scoped>
	[data-element='text'] {
		font-size:rem(12);
		color:$c-text;
		margin: 0 0 20px 0;
	}

	.page {
		&__info {
			margin-bottom: 24px;
		}

		&__nav-menu {
			display: flex;
			gap: 12px;
			align-items: center;
			margin-bottom: 20px;
			@include font();

			&__link {
				padding: 5px 5px;
				box-sizing: border-box;
				font-size: 20px;
				line-height: 24px;
				color: $c-dark-navy;
				border-radius: 8px;
				transition: background 0.2s ease;

				&:hover {
					background: $c-white-d2;
				}

				&-active {
					border-bottom: 2px solid $c-dark-navy !important;
					border-radius: 8px 8px 0px 0px !important;
				}

			}
		}
	}

	.deal-packs {
		display: grid;
		gap: 30px;

		&__list {
			display: grid;
			gap: 12px;
			grid-template-columns: 1fr 1fr 1fr;

			@media (max-width: 767px) {
				grid-template-columns: 1fr;
			}
		}
	}
</style>
